import React from 'react';
import { ListItemIcon, Typography } from '@mui/material';
import { getTheme } from '../../Theme/ThemeProvider';
import { MenuText, StyledListItem } from './LeftSideMenu.styles';
import { MenuItem as MenuItemType } from './LeftSideMenu.types';
import { SubMenu } from './SubMenu';

interface MenuItemProps {
  item: MenuItemType;
  index: number;
  activeSubmenuIndex: number | null;
  onMouseEnter: (index: number) => void;
  onMouseLeave: () => void;
}

export const MenuItem: React.FC<MenuItemProps> = ({ 
  item, 
  index, 
  activeSubmenuIndex, 
  onMouseEnter, 
  onMouseLeave 
}) => {
  const theme = getTheme();
  
  return (
    <StyledListItem 
      theme={theme}
      disabled={item.disabled}
      onMouseEnter={() => onMouseEnter(index)}
      onMouseLeave={onMouseLeave}
      onClick={!item.subItems ? item.action : undefined}
      sx={{ position: 'relative' }}
    >
      <ListItemIcon 
        sx={{ 
          minWidth: 'auto',
          justifyContent: 'center',
          color: item.disabled ? 'rgba(255, 255, 255, 0.5)' : theme.palette.common.white,
          transition: 'color 0.2s ease',
        }}
      >
        {item.icon}
      </ListItemIcon>
      {!item.subItems && (
        <MenuText className="menu-text" theme={theme} sx={{display: 'flex'}}>
          <Typography variant="body1">
            {item.text}
          </Typography>
          {item.actionIcon}
        </MenuText>
      )}

      {/* Render submenu if available */}
      {item.subItems && (
        <SubMenu
          subItems={item.subItems} 
          isVisible={activeSubmenuIndex === index} 
          theme={theme}
        />
      )}
    </StyledListItem>
  );
};